import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";
import { AbstractControl } from "@angular/forms";

@Injectable()
export class AuthValidators {
    public static auth: AuthService;

    constructor(public auth: AuthService) {
        AuthValidators.auth = auth;
    }

    public validateUniqueEmail(control: AbstractControl): Promise<{ [key: string]: any }> {
        const self = this;
        const auth = (self && self.auth) || AuthValidators.auth;

        return new Promise((resolve, reject) => {
            if (!control.value || !auth) {
                return resolve(null);
            }

            auth.signupCheck("user.email", control.value).subscribe(
                result => resolve(result.success ? null : { unique: true }),
                reject
            );
        });
    }

    public validatePasswordsMatch(sourceControl: AbstractControl): any {
        return (control: AbstractControl) => {
            return control.value === sourceControl.value ? null : { passwords_mismatch: true };
        };
    }
}
